import { PATHS } from "@/routes/paths";

/**
 * Mapeia o `Link` de cada submenu (string vinda do back, formato Pascal-Case com hifens —
 * ex.: "Pedidos-Compras") para o PATH front correspondente. Compartilhado entre Sidebar (que
 * navega) e Breadcrumb (que resolve `pathname` → menu).
 *
 * Submenus cujo link não está mapeado aqui são filtrados pelo Sidebar (não renderizam), o
 * que mantém o menu coerente com as rotas implementadas.
 */
export const LINK_TO_PATH: Record<string, string> = {
  // Raiz
  Dashboard: PATHS.dashboard,

  // Compras
  Fornecedores: PATHS.fornecedores,
  "Pedidos-Compras": PATHS.pedidosCompra,
  Recebimento: PATHS.recebimento,

  // Ocorrências
  Ocorrencias: PATHS.ocorrencias,

  // Gestão de Vendas
  Simulacoes: PATHS.simulacoesVenda,
  "Pedidos-Venda": PATHS.pedidosVenda,
  Vendas: PATHS.vendas,

  // Instalação
  Agenda: PATHS.agenda,
  "Minhas-OS": PATHS.minhasOs,
  "Inspecao-Qualidade": PATHS.inspecaoQualidade,
  "Indicadores-Qualidade": PATHS.indicadoresQualidade,
  "Garantia-Terceiro": PATHS.garantiaTerceiro,

  // Comissões
  "Precos-Loja": PATHS.precosPorLoja,
  "Precos-Por-Loja": PATHS.precosPorLoja,
  Comissionados: PATHS.comissionados,
  "Regras-Comissao": PATHS.regrasComissao,
  "Regras-Comissao-Padrao": PATHS.regrasComissao,
  "Campanhas-Incentivo": PATHS.campanhasIncentivo,
  "Valores-Instalacao": PATHS.valoresInstalacao,
  "Pagamento-Comissao": PATHS.pagamentoComissao,
  "Aprovacao-Comissao": PATHS.aprovacaoComissao,

  // Fiscal
  "Dashboard-Fiscal": PATHS.dashboardFiscal,
  "Regras-Tributacao": PATHS.regrasTributacao,
  "Apuracao-IRPJ-CSLL": PATHS.apuracaoIRPJeCSLL,
  "Relatorio-Fiscal": PATHS.relatorioFiscal,

  // Estoque
  Produtos: PATHS.produtos,
  Movimentacoes: PATHS.movimentacoes,
  "Posicoes-Estoque": PATHS.posicaoEstoque,
  Inventarios: PATHS.inventarios,
  "Recebimentos-Transferencia": PATHS.recebimentosTransferencia,
  "Rastreamento-Etiquetas": PATHS.rastreamentoEtiquetas,

  // Concessionárias
  Concessionarias: PATHS.concessionarias,

  // Empresas
  Empresas: PATHS.empresas,

  // Auditoria (menu direto, Link "Auditoria")
  Auditoria: PATHS.auditoria,

  // Usuários
  Usuarios: PATHS.usuarios,
  Perfis: PATHS.perfis,

  // Configurações
  "Whitelist-Dominios": PATHS.whitelistDominios,
  "Politica-Senhas": PATHS.politicaSenhas,
  "Configuracoes-Sessao": PATHS.configuracaoSessao,
  Marcas: PATHS.marcas,
  "Categorias-Produto": PATHS.categoriasProduto,
  "Categorias-Fornecedor": PATHS.categoriasFornecedor,
  "Regras-Compras": PATHS.regrasCompras,
};

/**
 * Rotas que não aparecem na árvore de menus do back (perfil próprio, sub-páginas internas)
 * mas que precisam de breadcrumb. Indexado pelo pathname exato.
 */
export const PATH_LABELS: Record<string, { parent?: string; current: string }> =
  {
    [PATHS.meuPerfil]: { current: "Meu Perfil" },
    [PATHS.importarUsuarios]: {
      parent: "Usuários",
      current: "Importar Usuários",
    },
  };
